module.exports = __webpack_public_path__ + "img/default.6e068701.png";